import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import overlayimg from "./../../assets/images/resource/uipath.jpg";
import FooterOne from "../Footer/FooterOne";
import aiAccounting from "./../../assets/images/banner/rpa-banner.png";


const AI_RPA_Support = () => {
  pageTitle("AI & RPA Support");

  return (
    <>
      <HeaderOne></HeaderOne>
      <div className="ai-overlay-wrapper" style={{ backgroundImage: `url(${aiAccounting})` }}>
        {/* <img src={aiAccounting} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Left corner image */}
          <img
            src={overlayimg}
            alt="RPA Icon"
            className="ai-overlay-corner-img"
          />
          <h2 className="rpa-af-title coe">
            RPA SUPPORT & MAINTENANCE
          </h2>
        </div>
      </div>

      <section className="siw-rpa-support-intro">
        <div className="container">
          <ul className="siw-rpa-question-list">
            <li>
              <span className="siw-rpa-qmark">?</span>
              Have you recently completed an RPA implementation?
            </li>
            <li>
              <span className="siw-rpa-qmark">?</span>
              Are you facing challenges in maintaining and supporting your
              software bots?
            </li>
            <li>
              <span className="siw-rpa-qmark">?</span>
              Have you recently lost an RPA administrator or need additional
              support to manage expanding automation demands?
            </li>
            <li>
              <span className="siw-rpa-qmark">?</span>
              Are high-value initiatives being delayed because your team is
              focused on RPA administration?
            </li>
          </ul>

          <p style={{ marginBottom: "30px", fontSize: "20px" }}>
            With any system, maintenance is required to keep it efficient. Our
            automation specialists help manage and support your RPA environment.
          </p>

          <div className="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>
              Let’s Build Your Intelligent Automation
            </h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              ensures your automation ecosystem runs smoothly, securely, and at
              peak performance with our comprehensive RPA support and
              maintenance services. We provide proactive monitoring, issue
              resolution, bot optimization, and continuous performance tuning to
              minimize downtime and maximize ROI. Our team ensures version
              upgrades, compliance alignment, infrastructure stability, and
              ongoing enhancements—so your automation solutions remain scalable,
              resilient, and business-ready at all times.
            </p>
            <h4>
              Call us at{" "}
              <a href="tel:+6590059743" style={{ color: "rgb(230, 233, 55)" }}>
                +65 9005 9743
              </a>{" "}
              to discuss your RPA Support
            </h4>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Schedule a Meeting
            </a>
          </div>
        </div>
      </section>
      <section className="siw-rpa-services">
        <div className="container">
          <h2 className="siw-rpa-services-title">
            Our RPA Support & Maintenance Services
          </h2>

          <div className="siw-rpa-services-grid">
            <div className="siw-rpa-card">
              <div className="siw-rpa-card-title">
                <i className="fa-solid fa-gears"></i>
                <h4> Operational Support</h4>
              </div>

              <ul>
                <li>Bot execution monitoring and reporting</li>
                <li>Automation environment management</li>
                <li>Monthly performance metrics and dashboards</li>
              </ul>
            </div>

            <div className="siw-rpa-card">
              <div className="siw-rpa-card-title">
                <i className="fa-solid fa-user-gear"></i>
                <h4> User Access &amp; Management</h4>
              </div>

              <ul>
                <li>New user provisioning</li>
                <li>Role and permission maintenance</li>
                <li>License administration</li>
              </ul>
            </div>

            <div className="siw-rpa-card">
              <div className="siw-rpa-card-title">
                <i className="fa-solid fa-screwdriver-wrench"></i>
                <h4> RPA Support &amp; Maintenance</h4>
              </div>

              <ul>
                <li>Level 1, 2, and 3 support services</li>
                <li>Access and credential management</li>
                <li>Issue resolution, troubleshooting, and debugging</li>
                <li>Process optimization and performance tuning</li>
                <li>Vendor coordination and support</li>
              </ul>
            </div>

            <div className="siw-rpa-card">
              <div className="siw-rpa-card-title">
                <i className="fa-solid fa-server"></i>
                <h4> RPA Infrastructure Management</h4>
              </div>

              <ul>
                <li>Platform upgrades and patching</li>
                <li>Log monitoring and system cleanup</li>
                <li>Deployment of additional servers and components</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};

export default AI_RPA_Support;
